import Big from 'big.js';

export const convertToGramsIfNeeded = ({ amount, measurementType }) => {
  if (measurementType === 'KG') {
    return amount * 1000;
  }

  // Should probably do something here if this is mls or litres or something as
  // that will balls things up
  return amount;
};

export const convertGramsToKgsIfNeededWithType = amount => {
  if (amount > 1000) {
    return {
      amount: new Big(amount).div(1000).toFixed(2),
      measurementType: 'KG'
    };
  }

  return {
    amount: new Big(amount).toFixed(2),
    measurementType: 'G'
  };
};

export const calculateTotals = ingredients => {
  const totals = ingredients.reduce(
    (total, i) => {
      return {
        hops: new Big(total.hops).plus(i.type === 'HOPS' ? convertToGramsIfNeeded(i) : 0),
        grain: new Big(total.grain).plus(i.type === 'GRAIN' ? convertToGramsIfNeeded(i) : 0)
      };
    },
    {
      hops: 0,
      grain: 0
    }
  );

  totals.grain = convertGramsToKgsIfNeededWithType(totals.grain);
  totals.hops = convertGramsToKgsIfNeededWithType(totals.hops);
  return totals;
};



// WEBPACK FOOTER //
// ./src/utils/ingredients.js